import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";

export default function MANoList({setModalOpen}) {
    const laung = localStorage.getItem("laung");
    const path = "Assets/scss/FirstTimeUsers.module.scss";
    const [lan, setLan] = useState(laung ?? "en");
    const navigate = useNavigate();
    useEffect(() => {
        LoadCSSforfirstTime(path);
    }, [path]);

    return (
        <></>
        // <div className="col-md-8 mx-auto signuppage">
        //     <div className="col-md-6 mx-auto text-center">
        //         <img
        //             src={`${CloudStorage.cloudurl}/Assets/Images/common/tick-back.svg`}
        //             alt=""
        //         />
        //         <h2>You don’t have any company listed here.</h2>
        //         <p>Lorem ipsum dorem sit emit consectitur di dores.</p>
        //     </div>
        //     <div className="visit">
        //         <button onClick={() => setModalOpen(true)} className="btn">
        //             + Add company
        //         </button>
        //     </div>
        // </div>
    );
}
